<template>
  <Breadcrumbs
    title="Daily Sales Monitoring Report"
    :breadcrumbs="[
      { label: 'Reports', path: '' },
      { label: 'Daily Sales Monitoring Report', path: '/daily-sales-monitoring-report' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <DailySalesMonitoringForm />
    </div>
  </div>
</template>

<script>
import DailySalesMonitoringForm from './dailysalesmonitoring_form.vue';

export default {
  name: "DailySalesMonitoringPage",
  components: {
    DailySalesMonitoringForm,
  },
};
</script>

